// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SystemBuilderType from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderType";
import { CustomAppState } from "@plumberssupply/App/Store/Reducers";
import { mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    unitaryImageSrc: string;
    miniSplitImageSrc: string;
    extendedStyles?: SystemBuilderTypesViewStyles;
}

export interface SystemBuilderTypesViewStyles {
    typesWrapper?: InjectableCss;
}

type Props = OwnProps;

export const systemBuilderTypesViewStyles: SystemBuilderTypesViewStyles = {};

const SystemBuilderTypesView: FC<Props> = ({ extendedStyles, unitaryImageSrc, miniSplitImageSrc }) => {
    const [styles] = useState(() => mergeWithCss(systemBuilderTypesViewStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.typesWrapper}>
            <SystemBuilderType
                type="unitary"
                imageSrc={unitaryImageSrc}
                title={`${translate("Unitary Heat Pump")}`}
                description={`${siteMessage("Custom_SystemBuilder_UnitaryTypeDescription")}`}
            />
            <SystemBuilderType
                type="miniSplit"
                imageSrc={miniSplitImageSrc}
                title={`${translate("Mini-Split")}`}
                description={`${siteMessage("Custom_SystemBuilder_MinisplitTypeDescription")}`}
            />
        </StyledWrapper>
    );
};

export default SystemBuilderTypesView;
